/**
 *
 *  This function generates an array of common links for the "Get Started" section
 *  of a navigation menu. It includes links for becoming a caregiver, success on Care.com
 *  and accessing the safety center.
 *  @param baseURL - The base URL for the application.
 *  @returns An array of link objects, each containing kind, id, href, value, and linkType.
 *
 */

export const getStartedCommonLinks = (baseURL: string): any => [
  { kind: 'label', value: 'Get started', id: 'get-started' },
  {
    kind: 'link',
    id: 'become-caregiver',
    href: `${baseURL}/hiw/caregivers`,
    value: 'Become a caregiver',
    linkType: 'primary',
    bold: true,
  },
  {
    kind: 'link',
    id: 'success-on-care',
    href: `${baseURL}/hiw/caregivers/new-provider-education`,
    value: 'Success on Care.com',
    linkType: 'primary',
  },
  {
    kind: 'link',
    id: 'safety-center',
    href: `${baseURL}/about/safety`,
    value: 'Safety center',
    linkType: 'primary',
  },
];
